'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lingojsCore = require('@bookingcom/lingojs-core');

function monthNames(i18n, options) {
    if (!i18n) {
        throw new Error('No i18n object provided');
    }
    return [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december'
    ].reduce(function (result, weekDay, index) {
        result[weekDay] = i18n.trans(lingojsCore.t('month_for_formatted_date', (index + 1).toString(), options.form));
        return result;
    }, {});
}

exports.monthNames = monthNames;
//# sourceMappingURL=month-names.js.map
